module.exports = __webpack_public_path__ + "img/kure-gold.7986b928.png";